export default __webpack_public_path__ + "static/media/docx_file.f79eeef9.svg";